import { useContext, useState } from "react";
import UserContext from "../../../services/Context/UserContext";
import API from "../../../services/API";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { Button, IconButton, Stack, Tooltip } from '@mui/material';
import { ContentCopy, Facebook, LinkedIn, Twitter } from "@mui/icons-material"
import ToastContext from "../../../services/Context/ToastContext"
import { LoadingButton } from "@mui/lab";
import { txt } from "../../../services/translation";

export default function SponsorLink(){

    const {user, setUser} = useContext(UserContext)

    const {setToast} = useContext(ToastContext)

    const [status, setStatus] = useState(user.sponsorCode ? 'ready' : 'missing')

    const statusIs = str => str === status
    const statusIn = arr => arr.includes(status)

    const generateCode = () => {

        setStatus('loading')

        API.post('/sponsor/code')
            .then(r => {
                setUser({...user, sponsorCode: r.data.sponsorCode})
                setStatus('ready')
            })
            .catch(e => setStatus('missing'))
    }

    const link = user.sponsorCode && 
        `${window.location.protocol}//${window.location.host}/app/affiliate/${user.sponsorCode}`;

    return (
            <>
                {statusIs('ready') &&
                    <Stack alignItems="center">
                        <CopyToClipboard 
                            text={link} 
                            onCopy={() => setToast({severity: 'success',  message: txt('linkCopiedMessage')})}
                        >
                            <Button endIcon={<ContentCopy />} sx={{ textTransform: 'lowercase' }}>
                                {link}
                            </Button>
                        </CopyToClipboard>
                        <Stack direction="row" gap={1}>
                        {networks.map(n => 
                            <Tooltip title={n.name} placement="top" key={n.name}>
                                <IconButton 
                                    href={n.url.replaceAll('{link}', encodeURI(link))}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    color="primary"
                                >
                                    {n.icon}
                                </IconButton>
                            </Tooltip>
                        )}
                        </Stack>
                    </Stack>
                }
        
                {statusIn(['missing','loading']) && 
                    <LoadingButton
                        onClick={generateCode}
                        loading={statusIs('loading')}
                        variant='contained'
                    >
                        {txt('generateMyLink')}
                    </LoadingButton>
                }
            </>
    );

}


const networks = [
    {
        name: 'Facebook',
        url: `https://www.facebook.com/sharer/sharer.php?u={link}`,
        icon: <Facebook />
    },
    {
        name: 'Twitter',
        url: `https://twitter.com/intent/tweet?url={link}&text={link}`,
        icon: <Twitter />
    },
    {
        name: 'LinkedIn',
        url: `https://www.linkedin.com/sharing/share-offsite/?url={link}`,
        icon: <LinkedIn />
    },

];

const encodeURI = (url) => encodeURIComponent(url);